import { MUIDatePicker as DatePicker, DataGrid, MUIButton, MUIDialog, MUISelect, MUITextField } from '@abb/arcadia-ui-react';
import { INVALID_SERVICE_VALUE, isValidInput, PO_NUMBER_MAX_LENGTH } from '@service/constants';
import dayjs from 'dayjs';
import moment from 'moment';
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from '@module/shared/routerCompat';
import { IConnectedComponent } from '../../../../../reducers';
import { Allocation, ILicenseAllowance, IServer } from '../../../models';

// TODO: Look for oppourtunities to reuse code and move functions to container component
/* tslint:disable:no-empty jsx-no-lambda jsx-self-close jsx-no-multiline-js*/
export class LicenseAllowanceTable extends React.Component<ILicenseAllowanceTableProps & IConnectedComponent, any> {

  constructor(props: ILicenseAllowanceTableProps & IConnectedComponent) {
    super(props);
    this.state = {
      serviceBeingEdited: new Allocation(this.props.match.params.siteId),
      productNameBeingEdited: null,
      mappedAllocations: [],
      isModalOpen: false,
      licenseAllowanceToDelete: null,
      allocatedBeingEdited: null,
      availableBeingEdited: null
    };
    this.handleProductNameChange = this.handleProductNameChange.bind(this);
    this.handleExpirationDateInputChange = this.handleExpirationDateInputChange.bind(this);
    this.renderExpirationDateTextInput = this.renderExpirationDateTextInput.bind(this);
  }

  render() {
    const isAdmin = this.props.userPermissions?.isAdmin;
    const headerData = isAdmin ? [
      { id: 'Service', label: 'Service', numeric: false, actions: false, enableSort: false },
      { id: 'AssetType', label: 'Asset Type', numeric: false, actions: false, enableSort: false },
      { id: 'Expiration', label: 'Expiration', numeric: false, actions: false, enableSort: false },
      { id: 'AssetCount', label: 'Asset Count', numeric: false, actions: false, enableSort: false },
      { id: 'Allocated', label: 'Allocated', numeric: false, actions: false, enableSort: false },
      { id: 'Available', label: 'Available', numeric: false, actions: false, enableSort: false },
      { id: 'PO', label: 'PO#', numeric: false, actions: false, enableSort: false },
      { id: 'Manage', label: 'Manage', numeric: false, actions: false, enableSort: false }
    ] : [
      { id: 'PO', label: 'PO#', numeric: false, actions: false, enableSort: false },
      { id: 'Service', label: 'Service', numeric: false, actions: false, enableSort: false },
      { id: 'AssetType', label: 'Asset Type', numeric: false, actions: false, enableSort: false },
      { id: 'Expiration', label: 'Expiration', numeric: false, actions: false, enableSort: false },
      { id: 'AssetCount', label: 'Asset Count', numeric: false, actions: false, enableSort: false },
      { id: 'Allocated', label: 'Allocated', numeric: false, actions: false, enableSort: false },
      { id: 'Available', label: 'Available', numeric: false, actions: false, enableSort: false }
    ];
    const rows = this.state.mappedAllocations.map((row: any, idx: number) => {
      const base: any = {
        id: String(row.allocation.id ?? idx),
        Service: this.renderServiceTypeComboBoxCol(row.allocation),
        AssetType: this.renderAssetType(row.allocation),
        Expiration: this.renderExpirationDateTextInput(row.allocation),
        AssetCount: this.renderTextCell(row.allocation, 'totalAssetAllocation', this.handleTotalAssetAllocationChange, this.handleAssetCountErrorMessage()),
        Allocated: this.renderAllocatedCell(row),
        Available: this.renderAvailableCell(row),
        PO: this.renderTextCell(row.allocation, 'productOrderNumber', this.handleProductOrderNumberChange, 'Alphanumeric field cannot exceed 10 characters')
      };
      if (isAdmin) {
        base.Manage = this.renderManageIcons(row.allocation);
      }
      return base;
    });

    return (
      <div>
        <DataGrid name='license-allowances' enableCheckbox={false} size={40} rowsPerPage={rows.length || 1} headerData={headerData} rows={rows} />
        <MUIDialog
          variant='warning'
          open={this.state.isModalOpen}
          heading='Confirmation'
          content='Deleting a service removes all corresponding instances. Please confirm.'
          primaryButtonText='Confirm'
          secondaryButtonText='Cancel'
          onClickPrimaryButton={() => {
            this.props.DeleteAllocation(this.state.licenseAllowanceToDelete, this.state.licenseAllowanceToDelete.siteId);
            this.setState({ isModalOpen: false, licenseAllowanceToDelete: null });
          }}
          secondaryButtonConfig={{ onClick: () => this.setState({ isModalOpen: false, licenseAllowanceToDelete: null }) }}
          onClose={() => { this.closeModal(); }}
        />
      </div>
    );
  }

  renderAssetType(allocation: ILicenseAllowance) {
    return allocation.id === this.state.serviceBeingEdited.id ? this.state.serviceBeingEdited.licensableService.assetType.assetTypeName : allocation.licensableService.assetType.assetTypeName;
  }
  renderTextCell(allocation: ILicenseAllowance, field: string, onChangeFunction: any, errorMessage: string) {
    if (allocation.isBeingEdited) {
      return <MUITextField name='LicenseAllowanceInput' size={32}
        value={this.state.serviceBeingEdited[field].value}
        errors={this.state.serviceBeingEdited[field].valid ? undefined : { LicenseAllowanceInput: { message: errorMessage } }}
        onChange={(value: string) => onChangeFunction.call(this, allocation, value)} />;
    }
    return allocation[field].value.toString();
  }
  renderExpirationDateTextInput(allocation: ILicenseAllowance) {
    if (allocation.isBeingEdited) {
      // this check allows us to bind the value of the field to serviceBeingEdited while still populating
      // the current expiration date initially, before serviceBeingEdited has been set to a new date
      if (this.state.serviceBeingEdited.expirationDateUtc === new Allocation().expirationDateUtc) {
        this.setState({ serviceBeingEdited: allocation });
      }
      const currentValue = this.state.serviceBeingEdited.expirationDateUtc.value;
      return <DatePicker
        key={`datepicker-${allocation.id}`}
        size={32}
        defaultValue={currentValue ? dayjs(moment(currentValue).toISOString()) : null}
        onChange={this.handleExpirationDateInputChange}
        errors={this.state.serviceBeingEdited.expirationDateUtc.valid ? undefined : { expirationDateUtc: { message: 'Must be a valid date' } }}
        minDate={dayjs().add(1, 'day')} />;
    }
    return moment(allocation.expirationDateUtc.value).format('MM/DD/YYYY');
  }

  handleExpirationDateInputChange(date: any) {
    const m = date ? moment(date.toDate()) : moment.invalid();
    this.setState((prevState: any) => ({
      serviceBeingEdited: {
        ...prevState.serviceBeingEdited,
        expirationDateUtc: { value: m, valid: !!date && date.isValid() }
      }
    }));
  }

  handleTotalAssetAllocationChange(allocation: ILicenseAllowance, value: any) {
    const indexBeingEdited = this.state.mappedAllocations.map((a: any) => a.allocation.isBeingEdited).indexOf(true);
    const actualAllocated = this.state.mappedAllocations[indexBeingEdited].allocatedAssets;
    const allocated = this.state.allocatedBeingEdited == null ? actualAllocated : Number.parseInt(this.state.allocatedBeingEdited, 10);
    const available = Number.parseInt(value, 10) - allocated;
    this.setState((prevState: any) => ({
      availableBeingEdited: isNaN(available) ? '' : String(available),
      serviceBeingEdited: {
        ...prevState.serviceBeingEdited,
        totalAssetAllocation: {
          value,
          valid: !Number.isNaN(Number(value)) && Number.parseInt(value, 10) >= actualAllocated && Number.parseInt(value, 10) > 0
        }
      }
    }));
  }

  renderAllocatedCell(row: any) {
    if (row.allocation.isBeingEdited) {
      const value = this.state.allocatedBeingEdited ?? String(row.allocatedAssets);
      return <MUITextField name='AllocatedInput' size={32}
        value={value}
        isDisabled={true} />;
    }
    return row.allocatedAssets.toString();
  }

  renderAvailableCell(row: any) {
    if (row.allocation.isBeingEdited) {
      const value = this.state.availableBeingEdited ?? String(row.availableAssets);
      return <MUITextField name='AvailableInput' size={32}
        value={value}
        isDisabled={true} />;
    }
    return row.availableAssets.toString();
  }

  handleAssetCountErrorMessage() {
    return (this.props.allocationIsAddingNew) ? 'Number must be greater than zero' : 'Number must be greater than or equal to the allocated amount';
  }

  handleProductOrderNumberChange(allocation: ILicenseAllowance, value: any) {
    this.setState((prevState: any) => ({
      serviceBeingEdited: {
        ...prevState.serviceBeingEdited,
        productOrderNumber: {
          value,
          valid: isValidInput(value, PO_NUMBER_MAX_LENGTH)
        }
      }
    }));
  }

  renderServiceTypeComboBoxCol = (allocation: ILicenseAllowance) => {
    if (allocation.isBeingEdited && allocation.licensableService.productName === '') {
      let options: Array<{ label: any; value: any; assetType: any; licenseParameters?: any; licensePassword?: any; }> = [];
      this.props.serviceOptions.licensableServices.forEach((service: any) => {
        const optionToAdd = {
          label: service.productName,
          value: service.id,
          assetType: service.assetType.assetTypeName,
          licenseParameters: service.assetType.licenseParameters,
          licensePassword: service.assetType.licensePassword
        };
        options.push(optionToAdd);
      });
      if (this.state.serviceBeingEdited.licensableService.productName !== allocation.licensableService.productName && this.state.serviceBeingEdited.licensableService.productName && !options.some((option: any) => option.label === allocation.licensableService.productName)) {
        options.push({
          label: allocation.licensableService.productName,
          value: allocation.licensableService.id,
          assetType: allocation.licensableService.assetType.assetTypeName,
          licenseParameters: allocation.licensableService.licenseParameters,
          licensePassword: allocation.licensableService.licensePassword
        });
      }
      const availableOptions = options.filter((licensableService: any) => licensableService.value !== INVALID_SERVICE_VALUE);
      const dropdownLOV = availableOptions.map((o: any) => ({ id: String(o.value), name: o.label }));
      const selected = this.state.productNameBeingEdited && this.state.productNameBeingEdited.value != null ? [String(this.state.productNameBeingEdited.value)] : [];
      return <MUISelect name='serviceType' size={32} dropdownLOV={dropdownLOV} selectedItem={selected} onChange={(value: any) => {
        const first = Array.isArray(value) ? value[0] : value;
        const id = Array.isArray(value) && typeof first === 'object' && first !== null ? first.id : first;
        const picked = availableOptions.find((o: any) => String(o.value) === String(id));
        if (picked) { this.handleProductNameChange(picked); }
      }} />
    }
    return allocation.licensableService.productName;
  }

  renderManageIcons = (allocation: ILicenseAllowance) => {
    if (allocation.isBeingEdited) {
      return <div className="flex-start">
        <MUIButton variant='secondary' size={32} iconName='icon_abb_dias icon-abb_save' disabled={!this.state.serviceBeingEdited.expirationDateUtc.valid || !this.state.serviceBeingEdited.productOrderNumber.valid || !this.state.serviceBeingEdited.totalAssetAllocation.valid} onClickButton={() => this.handleUpdateAllocation(this.state.serviceBeingEdited)} />
        <MUIButton variant='secondary' size={32} iconName='icon_abb_dias icon-abb_cancel-1' onClickButton={() => this.handleCancelAllocationEdit(allocation)} />
      </div>;
    }
    return <div className="flex-start">
      <MUIButton variant='secondary' size={32} iconName='icon_abb_dias icon-abb_edit' disabled={this.props.allocationIsAddingNew} onClickButton={() => this.handleEditExistingRow(allocation, this.props.match.params.siteId)} />
      <MUIButton variant='secondary' size={32} iconName='icon_abb_dias icon-abb_delete' disabled={this.props.allocationIsAddingNew} onClickButton={() => {
        this.setState({
          isModalOpen: true,
          licenseAllowanceToDelete: allocation
        });
      }} />
    </div>;
  }

  closeModal() {
    this.setState({
      isModalOpen: false,
      licenseAllowanceToDelete: null
    });
  }

  handleProductNameChange(productType: any) {
    const serviceList = this.props.serviceOptions.licensableServices.filter((licensableService: any) => licensableService.id === productType.value);
    this.setState((prevState: any) => ({
      serviceBeingEdited: {
        ...prevState.serviceBeingEdited,
        licensableService: serviceList.length > 0 ? serviceList[0] : {
          assetType: { assetTypeName: productType.assetType, id: productType.id },
          id: productType.id,
          licenseParameters: productType.licenseParameters,
          licensePassword: productType.licensePassword,
          productName: productType.label
        }
      },
      productNameBeingEdited: {
        label: productType.label,
        value: productType.value
      }
    }));
  }

  handleUpdateAllocation(serviceBeingEdited: any) {
    if (serviceBeingEdited.id === -1) {
      this.props.addAllocation(serviceBeingEdited);
    } else { this.props.UpdateAllocation(serviceBeingEdited); }
    this.setState({ serviceBeingEdited: new Allocation(this.props.match.params.siteId), productNameBeingEdited: '', allocatedBeingEdited: null, availableBeingEdited: null });
  }

  handleCancelAllocationEdit(serviceBeingEdited: any) {
    this.props.CancelAllocationEdit(serviceBeingEdited);
    this.setState({ serviceBeingEdited: new Allocation(this.props.match.params.siteId), productNameBeingEdited: '', allocatedBeingEdited: null, availableBeingEdited: null });
  }

  handleEditExistingRow(allocation: any, siteId: number) {
    this.setState((prevState: any) => {
      const mapped = prevState.mappedAllocations.filter((m: any) => m.allocation.id === allocation.id)[0];
      return {
        serviceBeingEdited: allocation,
        productNameBeingEdited: { label: allocation.licensableService.productName, value: allocation.licensableService.assetType.id },
        allocatedBeingEdited: mapped ? String(mapped.allocatedAssets) : '0',
        availableBeingEdited: mapped ? String(mapped.availableAssets) : '0'
      };
    });
    this.props.EditExistingRow(allocation, siteId);
  }

  componentWillReceiveProps(nextProps: any) {
    this.setState({
      mappedAllocations: nextProps.licenseAllowances.map((licenseAllowances: ILicenseAllowance) => {
        const allocatedAssets = nextProps.server.map((server: IServer) => {
          return server.serviceAllocations.map((serviceAllocation: any) => {
            if (serviceAllocation.selectedServiceType.productName === licenseAllowances.licensableService.productName) {
              return serviceAllocation.allocatedAssets.value;
            }
            return 0;
          }).reduce((a: number, b: number) => {
            return Number(a) + Number(b);
          }, 0);
        }).reduce((first: number, second: number) => Number(first) + Number(second), 0);
        return {
          allocation: licenseAllowances,
          allocatedAssets,
          availableAssets: licenseAllowances.totalAssetAllocation.value - allocatedAssets,
        };
      })
    });
  }
}

export default withRouter(connect(mapStateToProps)(LicenseAllowanceTable) as any);

export function mapStateToProps(store: any) {
  return { ...store.servicesState, ...store.serviceOptionsState, ...store.serverState, userPermissions: store.userState.userPermissions };
}

export interface ILicenseAllowanceTableProps {
  licenseAllowances: ILicenseAllowance[];
  serviceOptions: any;
  requestServices: any;
  addAllocation: any;
  AddNewEditableRow: any;
  EditExistingRow: any;
  CancelAllocationEdit: any;
  UpdateAllocation: any;
  DeleteAllocation: any;
  allocationIsAddingNew: boolean;
  match: any;
  server: any;
  permissions: string[];
  errorMessage: string;
  licenseAllowanceErrorMessageVisible: boolean;
  clearErrorMessage: any;
}
